/**
 * Import_Service.ts
 * Bulk upsert up to 5,000 catalog items per batch.
 * Returns 207 Multi-Status — each item has its own success/error entry.
 * (sk-catalog-api /api/v1/import)
 */

import axiosInstance from '../../api/axiosInstance';
import { Catalog_Import_Url } from '../../api/endpoints';

/* ─────────────────────────────────────────
   Response shape: { total, created, updated, skipped, errors[] }
───────────────────────────────────────── */

export interface ImportErrorEntry {
  index?:          number;
  skuOrReference?: string;
  error:           string;
}

export interface ImportResponse {
  total:   number;
  created: number;
  updated: number;
  skipped: number;
  errors:  ImportErrorEntry[];
}

/* ─────────────────────────────────────────
   Import — POST /api/v1/import
   Up to 5,000 items per batch.
   NOTE: axios resolves 207 as a successful response (status < 300).
───────────────────────────────────────── */

export const importItems = async (items: Record<string, any>[]): Promise<ImportResponse> => {
  const { data } = await axiosInstance.post<ImportResponse>(Catalog_Import_Url, { items });
  return data;
};
